import { createAction } from 'redux-actions';

export interface setFiltersAction {
	payload: {
		type: keyof types.redux.numbers.Filters;
		value: string[];
	};
}

export const setFilters: any = createAction('SET_FILTERS');
